import SupplierInfo from './SupplierInfo';
export default SupplierInfo;
